import { openOnDashboard } from "../../alert/functions/open-on-dashboard.js";
import { useAlertStore } from "../../alert/store/alertStore.js";
import { loggingContexts } from "../../root/modules/logs/data/logging-contexts.js";
import { log } from "../../root/modules/logs/log.js";

const notifyLog = log(loggingContexts.notify);

export const notify = ({ caseID, messagePayload }) => {
  if (!messagePayload?.data) {
    notifyLog.warn("notify was called without data", messagePayload);

    return;
  }

  const caseNumber = messagePayload?.displayMessage?.caseNumber;

  const { complaint, emsAgency, eventName, truck } = messagePayload.data;

  const notificationTitle = "TigerConnect Alerter";

  notifyLog.info("notifying", { complaint, emsAgency, eventName, truck });

  const notification = new Notification(notificationTitle, {
    body: `${complaint?.name ?? "'No complaint'"} case from ${
      emsAgency?.name ?? "'No agency'"
    } - ${truck?.name ?? "'No truck'"}: ${eventName ?? "'No event'"}`,
    icon: "/logo-squared.png",
  });

  const alertStore = useAlertStore();

  notification.addEventListener("click", () => {
    openOnDashboard({
      browserCommand: alertStore.browserCommand,
      caseID,
      caseNumber,
      closeWindow: false,
    });
  });
};
